export default __webpack_public_path__ + "static/media/loading.21a2ee25.gif";